export enum TaxRiskReportingRouteSegment {
  HealthChecksOnBeneficialOwners = 'health-checks-on-beneficial-owners',
  HealthChecksOnTaxRateTables = 'health-checks-on-tax-rate-tables',
  TaxReclaimAccrualChecks = 'tax-reclaim-accrual-checks',
}
